<template>
  <div class="feedback pop">
    <div class="pop-box">
      <div class="pop-main">
        <div v-if="!feedbackSuccess">
          <div class="pop-main-top">{{$t('list.feedback')}}</div>
          <textarea name="" id="" :class="{'active': active}" v-model="textareaVal" :placeholder="$t('list.feedbackPlaceholder')"></textarea>
          <div class="pop-main-bottom">
            <button class="btn-black" @click="submitFeedback(textareaVal)">{{$t('list.submit')}}</button>
            <button class="btn-grey" @click="closeFeedbackPop">{{$t('list.cancel')}}</button>
          </div>
        </div>
        <div class="pop-main-wrapper" v-if="feedbackSuccess">
          <div>
            <i class="icon-select"></i>
            <div class="successTip">{{$t('list.feedbackSuccess')}}</div>
          </div>
          <div class="pop-main-bottom">
            <button class="btn-black" @click="closeFeedbackPop">{{$t('operation.done')}}</button>
          </div>
        </div>
        <i class="icon-close" @click="closeFeedbackPop"></i>
      </div>
    </div>
  </div>
</template>

<script>
import * as Config from 'common/script/config'
export default {
  name: 'feedback',
  props: ['feedbackSuccess'],
  data () {
    return {
      textareaVal: '',
      active: false
    }
  },
  created () {
  },
  watch: {
    textareaVal: function (newFolder, oldFolder) {
      this.textareaVal = Config.removeEmoji(this.textareaVal)
    }
  },
  methods: {
    submitFeedback: function (val) {
      if (this.textareaVal === '') {
        this.active = true
      } else {
        this.active = false
        this.$emit('submitFeedback', val)
      }
    },
    closeFeedbackPop: function () {
      this.$emit('closeFeedbackPop')
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.feedback
  &.pop
    .pop-box
      width 420px
      height 340px
      .pop-main
        textarea
          width 380px
          height 230px
          position absolute
          top 55px
          left 20px
          font-size 12px
          color #999
          background-color #f5f5f5
          padding 9px
          box-sizing border-box
          border-radius 4px
          resize none
          border 1px solid #f5f5f5
          outline none
          &::-webkit-input-placeholder
            color #999
          &.active
            border 1px solid #e36868
        .pop-main-wrapper
          width 100%
          height 100%
          display flex
          justify-content center
          align-items center
          padding 35px 0 50px
          box-sizing border-box
          i.icon-select
            display block
            font-size 38px
            margin-bottom 15px
          .successTip
            font-size 12px
            font-weight bold
</style>



// WEBPACK FOOTER //
// src/components/Feedback.vue